import { render } from "./code.vue?vue&type=template&id=5b79510b"
import script from "./code.vue?vue&type=script&lang=ts"
export * from "./code.vue?vue&type=script&lang=ts"

import "./code.vue?vue&type=style&index=0&id=5b79510b&lang=scss"
script.render = render

export default script